import { ReactNode } from 'react';
import { css } from '@emotion/react';

import libraryVars from '@/library/assets/scss/abstracts/_exports.module.scss';

const highlightCss = css`
  background-color: color-mix(in srgb, ${libraryVars.butterYellow} 60%, transparent);
  border-radius: ${libraryVars.borderRadiusBase};
`;

export const highlightSearchMatch = (text: string, searchQuery: string): ReactNode => {
  const highlightValue = searchQuery.trim();
  if (!highlightValue) return text;

  const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const searchRegex = new RegExp(`(${escapeRegex(highlightValue)})`, 'gi');
  const parts = text.split(searchRegex);

  return parts.map((part, index) => {
    if (part.toLowerCase() === highlightValue.toLowerCase()) {
      return (
        <span key={index} css={highlightCss}>
          {part}
        </span>
      );
    }

    return part;
  });
};
